import type { ReactElement } from 'react';
import React from 'react';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import type { LineThicknessOptionProps} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-thickness-option.tsx/line-thickness-option.types';
import {LINE_THICKNESS_MAX, LINE_THICKNESS_MIN} from '@Components/poster-editor/components/poster-editing-side-panel/components/line-thickness-option.tsx/line-thickness-option.types';
import {ContextualMenuSliderOptions} from '@Components/contextual-menu/components/contextual-menu-slider-options';
import {useGetKeyFromLineItem} from '@Hooks/poster-editor/useGetKeyFromLineItem';

export function LineThicknessOption({min = LINE_THICKNESS_MIN}: LineThicknessOptionProps ): ReactElement<any>  {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemScaleY = useGetKeyFromLineItem('scaleY');
  const activeItemHeight = useGetKeyFromLineItem('height')
  if (!activeItem || activeItemScaleY === undefined || activeItemHeight === undefined) {
    throw new Error(`Item doesn't have thickness property`);
  }

  const refreshFabricObject = (): void => {
    const pageHashedId = window.posterEditor?.whiteboard?.getCurrentPageId();
    if (!pageHashedId) {
      return;
    }
    const page = window.posterEditor?.whiteboard?.pages.getPage(pageHashedId);
    if (!page) {
      return;
    }
    activeItem.fabricObject.setCoords();

    page.fabricCanvas.requestRenderAll();
  };
  const updateThickness = (thickness: number, undoable = true): void => {
    if (thickness <= 0) {
      return;
    }

    if (activeItem.fabricObject.height === 0) {
      return;
    }
    const newScaleY = thickness / activeItem.fabricObject.height;


    void activeItem.updateFromObject(
      {
        scaleY: newScaleY,
      },
      {
        undoable,
      }
    )
    refreshFabricObject()
  };

  const onChangeThickness = (updatedValue: number): void => {
    updateThickness(updatedValue, false);


  };

  const onChangeEnded = (updatedValue: number): void => {
    updateThickness(updatedValue);
  };

  return (
    <ContextualMenuSliderOptions
      id="line-thickness-option"
      value={activeItemHeight * activeItemScaleY}
      label={window.i18next.t('pmwjs_thickness')}
      range={{
        min,
        max: LINE_THICKNESS_MAX,
      }}
      transformDisplay={{
        min,
        max: 100,
      }}
      onChange={onChangeThickness}
      onChangeEnded={onChangeEnded}
    />
  );
}